export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-accent-400">爆瓜网</span>
            </a>
            <p className="text-xs text-background-300 leading-relaxed max-w-xs">
              专业的娱乐资讯聚合平台。每日更新娱乐新闻、明星动态、影视八卦和综艺热点，做最快最全最靠谱的吃瓜第一站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {['明星动态', '影视资讯', '综艺热点', '音乐圈', '八卦深挖'].map((item) => (
                <li key={item}>
                  <a
                    href="#cards"
                    className="text-xs text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快捷入口</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
                { label: '精彩视频', href: '#media' },
                { label: '爆料投稿', href: '#contact' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-xs text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-xs text-background-300 leading-relaxed">
              诚邀优质内容合作伙伴加入我们，共同打造更好的娱乐资讯生态。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {['WeChat', 'Weibo', 'Douyin', 'Bilibili', 'Xiaohongshu'].map((p) => (
                <span
                  key={p}
                  className="text-[10px] text-background-300 bg-background-800 px-2 py-1 rounded"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 爆瓜网 baogua.com. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#faq" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              常见问题
            </a>
            <a href="#contact" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              联系我们
            </a>
            <a href="#about" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}